import template from './labelsList.template.html';

export default {
  template,
  bindings: {
    labels: '=',
    onClick: '&',
    onChange: '&',
    onReady: '&'
  },
controller: class controller {
    constructor($rootScope, $filter, $mdMedia, listService) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      var ctrl = this;
      ctrl.$mdMedia = $mdMedia;
      ctrl.natural = $rootScope.natural;
      ctrl.list = listService;
      ctrl.list.clear();

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = function () {
        ctrl.list.setData(
          $filter('stStartingLetter')(ctrl.labels, ctrl.list.getGroupingByFirstLetter())
        );
        ctrl.onReady({ list: ctrl.list });
      };
      this.click = function ($event, data) {
        ctrl.onClick({ event: $event, data: data });
      };
      this.select = function (data) {
        var listData = null;
        if (data.length) {
          listData = _.filter(data, function (d) {
            return !d.isLocked;
          });
        } else {
          listData = data;
        }
        var isSelected = ctrl.list.setSelected(listData);
        ctrl.onChange({ list: ctrl.list, data: listData, isSelected: isSelected });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = function () {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      this.$onChanges = function (changes) {
        if (changes.labels && changes.labels.currentValue) {
          ctrl.initialize();
        }
      };
    }
  }
};
